var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 25.068 25.057",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "envelope-open",
    d: "M23.459,8.46,16.227,1.529a5.25,5.25,0,0,0-7.369-.016L1.609,8.46A5.252,5.252,0,0,0,0,12.229v7.617a5.229,5.229,0,0,0,5.223,5.223H19.846a5.229,5.229,0,0,0,5.223-5.223V12.229A5.249,5.249,0,0,0,23.459,8.46ZM10.319,3.006a3.147,3.147,0,0,1,4.448.017l7.047,6.752L14.75,16.839a3.211,3.211,0,0,1-4.431,0L3.254,9.774Zm12.661,16.84a3.134,3.134,0,0,1-3.134,3.134H5.223a3.134,3.134,0,0,1-3.134-3.134V12.229a3.148,3.148,0,0,1,.062-.6l6.691,6.691a5.248,5.248,0,0,0,7.385,0l6.691-6.691a3.148,3.148,0,0,1,.062.6Z",
    transform: "translate(0 -0.011)",
    fill: "#ff6036"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.28bd0a3f3e6b94ac06d2e889404f6867.svg";
export { ForwardRef as ReactComponent };